import { WithBillId } from '@mews-commander/types';
import { BulkCheckbox } from '@mews-commander/ui';
import { LocalizedText, useScope } from '@mews/framework';
import { Stack } from '@optimus-web/core';
import { TextKey } from '@mews-commander/enums';
import { useCommanderSelector, useCommanderThunkDispatch } from '@mews-commander/utils';
import {
    areAllBillItemsSelected,
    areSomeBillItemsSelected,
    isBillEmpty,
    toggleBillItemsSelect,
} from '../../../ducks/billItems';

interface CheckboxProps extends WithBillId {
    'data-test-id'?: string;
}

export const SelectAllCheckbox = ({ billId, 'data-test-id': dataTestId }: CheckboxProps) => {
    const dispatch = useCommanderThunkDispatch();
    const scope = useScope() ?? '';
    // @ts-expect-error
    const allSelected = useCommanderSelector((state) => areAllBillItemsSelected(state, { billId, scope }));
    const billEmpty = useCommanderSelector((state) => isBillEmpty(state, { billId }));
    // @ts-expect-error
    const someSelected = useCommanderSelector((state) => areSomeBillItemsSelected(state, { billId, scope }));

    const toggle = () => dispatch(toggleBillItemsSelect(billId, scope));

    return (
        <Stack>
            <BulkCheckbox
                allSelected={allSelected}
                data-test-id={dataTestId}
                data-select-all-checkbox={billId}
                onChange={toggle}
                someSelected={someSelected}
                disabled={billEmpty}
            >
                <LocalizedText textKey={TextKey.SelectAll} />
            </BulkCheckbox>
        </Stack>
    );
};
